import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import StructureModel from '@Components/Results/structure/structure-model.service';
import StructureZoomService from '@Services/StructureZoom';
import ReactTargetHelper from '@Components/Results/services/react-target-helper.service';
import Structure from '@Components/Results/structure/Structure';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';

import './TargetMostActiveSubstance.scss';

function formatStructure(structure, databaseId) {
  structure.databaseId = databaseId;
  return new StructureModel(structure);
}

function TargetMostActiveSubstance({ metadata, target, zoom }) {
  const zoomClasses = useMemo(() => StructureZoomService.getZoomClasses('tgitems') || [], []);
  const substanceEntity = useMemo(() => getValueByNs(target, 'mostActiveSubstanceDetails.substanceEntity'), [target]);
  const zoomClass = zoomClasses?.[zoom];
  const { isTestedSample } = ReactTargetHelper;

  // Mutate substanceEntity only if it exists
  if (substanceEntity) {
    substanceEntity.databaseId = target.databaseId;
  }

  return (
    <div className="target-active-substance">
      <span className="target-active-substance-caption">{isTestedSample(target) ? 'Example structure' : 'Most active substance:'}</span>

      <div className={`substance-item ${zoomClass}`}>
        {target.mostActiveSubstanceDetails && (
          <Structure metadata={metadata} structure={formatStructure(substanceEntity, target.databaseId)} zoom={zoom} />
        )}
      </div>

      <span className={`target-active-substance-property substance-item ${zoomClass}`}>
        {isTestedSample(target) ? 'No quantitative value reported' : target.mostActiveValue}
      </span>
    </div>
  );
}

TargetMostActiveSubstance.propTypes = {
  target: PropTypes.object.isRequired,
  zoom: PropTypes.number.isRequired,
  metadata: PropTypes.object,
};

export default TargetMostActiveSubstance;
